import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetQueryParamsFromFiltersByName } from '#/modules/search/routing/helpers/searchGetQueryParamsFromFiltersByName';
import { searchInternshipsPathReference } from '#/modules/search/routing/search.paths';
import type { SearchInternshipFiltersByName } from '#/modules/search/types/FiltersByName/SearchInternshipFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchInternshipsPathByLocale } from './searchInternships.paths';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchInternshipFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetInternshipsPath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchInternshipsPathReference
    .with(queryParams)
    .replace('/-lang/-segment', searchInternshipsPathByLocale[locale]);
}
